module.exports = __webpack_public_path__ + "static/media/instagram-icon.a3e62c9a.svg";